export class ClassTemplate {
    public _id: string;
    public name: string;
    public sequence: any[];
    public ownedBy: string;
    public gyms: any[];

    constructor() {}
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/models/classTemplate.ts